import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50df483c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-keypad" }

import BaseKey from '@/components/base/BaseKey.vue';
import useUpdate from '@/behaviours/useUpdate';

export type Props = {
  keyValues?: (string | number)[],
  isDisabled?: boolean,
  isInputBlocked?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppKeypad',
  props: {
    keyValues: { default: () => JSON.parse(process.env.VUE_APP_PIN_KEYS) },
    isDisabled: { type: Boolean, default: false },
    isInputBlocked: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { keyValues: (string | number)[], isDisabled: boolean, isInputBlocked: boolean };



const { pinUpdate } = useUpdate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.keyValues, (keyValue) => {
      return (_openBlock(), _createElementBlock("div", {
        key: keyValue,
        class: "app-keypad__item"
      }, [
        _createVNode(BaseKey, {
          class: "btn btn--primary",
          disabled: __props.isDisabled,
          value: keyValue,
          "is-cancel-hold": __props.isInputBlocked,
          "is-global-key-handler": true,
          onKeyPressed: _cache[0] || (_cache[0] = ($event: any) => (!__props.isInputBlocked && _unref(pinUpdate)($event)))
        }, null, 8, ["disabled", "value", "is-cancel-hold"])
      ]))
    }), 128))
  ]))
}
}

})